import React from 'react';
// Import TrebbleSelect
import TrebbleSelect from '../../../../common/TrebbleSelect';

interface Option {
    value: string | number;
    label: string;
    icon: React.ReactNode;
    description?: string;
}

interface IconDropdownProps {
    value: string | number;
    onChange: (value: string | number) => void;
    options: Option[];
    className?: string;
}

export const IconDropdown: React.FC<IconDropdownProps> = ({ value, onChange, options, className }) => {
    return (
        <TrebbleSelect<string | number, Option>
            value={value}
            onChange={onChange}
            options={options}
            className={`trebble-icon-select ${className ?? ''}`}
            popupClassName="trebble-icon-select-dropdown"
            optionLabelProp="label" // Keep this if you want the label to show in the collapsed state
            dropdownRender={(menu: React.ReactNode) => (
                <div className="py-1">
                    {menu}
                </div>
            )}
            optionRender={(option: { data: Option }) => (
                <div className="flex items-center gap-3 py-1 px-1">
                    <div className="w-5 h-5 flex items-center justify-center">
                        {option.data.icon}
                    </div>
                    <div className="flex flex-col">
                        <span className="text-sm font-medium">{option.data.label}</span>
                        {option.data.description && (
                            <span className="text-[var(--color-black-20)] dark:text-[var(--color-white-20)] text-xs">{option.data.description}</span>
                        )}
                    </div>
                </div>
            )}
        />
    );
};

 